import React, { useState, useEffect, useRef } from 'react';

/**
 * TextAnimation Component
 * Animates text with a staggered reveal effect (slide-up only, no fade).
 */
const TextAnimation = ({ text, className = "", staggerDelay = 0.03, style = {} }) => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );

    if (containerRef.current) observer.observe(containerRef.current);
    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, []);

  const letters = text.split("");

  return (
    <div 
      ref={containerRef} 
      className={className}
      style={{ 
        display: "inline-block",
        lineHeight: "1.2",
        ...style 
      }}
    >
      {letters.map((char, index) => (
        <span
          key={index}
          style={{
            display: "inline-block",
            overflow: "hidden", 
            verticalAlign: "bottom",
          }}
        >
          <span
            style={{
              display: "inline-block",
              whiteSpace: "pre",
              // Translation only - opacity is removed
              transform: isVisible ? "translateY(0)" : "translateY(110%)",
              opacity: 1, 
              transition: `transform 0.8s cubic-bezier(0.16, 1, 0.3, 1)`,
              transitionDelay: `${index * staggerDelay}s`,
            }}
          >
            {char === " " ? "\u00A0" : char}
          </span>
        </span>
      ))}
    </div>
  );
};

export default TextAnimation;